import { Box, Typography, useTheme } from '@mui/material'

interface FeatureItemProps {
  icon: React.ReactNode
  title: string
  description: string
}

export const FeatureItem = ({ icon, title, description }: FeatureItemProps) => {
  const theme = useTheme()

  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        borderRadius: '16px',
        backgroundColor: theme.palette.background.default,
        padding: '24px',
        textAlign: 'left',
        gap: 0.7
      }}
    >
      {icon}
      <Typography
        fontSize={'1.2rem'}
        fontWeight={theme.typography.fontWeightBold}
        color="primary.dark"
      >
        {title}
      </Typography>
      <Typography
        fontSize={'1rem'}
        fontWeight={theme.typography.fontWeightMedium}
        color={theme.palette.grey[600]}
      >
        {description}
      </Typography>
    </Box>
  )
}
